import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { OrganizationDTO } from './organization.dto';
import { OrganizationDetailDTO } from './organzation-detail.dto';
import { CompareGroupDTO } from './compare-group.dto';
import { CompareGroupMemberDTO, CompareGroupMemberListDTO } from './compare-group-member.dto';

@Injectable({
  providedIn: 'root'
})
export class CompareGroupService {

  constructor(private http: HttpClient) { }

  getCompareGroups(orgId: number): Observable<CompareGroupDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetCompareGroups?orgID=${orgId}`;
    return this.http.get<CompareGroupDTO[]>(apiUrl);
  }

  getCompareGroupMembers(compareGroupId: number): Observable<CompareGroupMemberDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetCompareGroupMembers?compareGroupId=${compareGroupId}`;
    return this.http.get<CompareGroupMemberDTO[]>(apiUrl);
  }

  getOrgIDs(): Observable<OrganizationDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetOrgIDs`;
    return this.http.get<OrganizationDTO[]>(apiUrl);
  }

  getOrgList(): Observable<OrganizationDetailDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetOrgList`;
    return this.http.get<OrganizationDetailDTO[]>(apiUrl);
  }

  deleteCompareGroup(id: number): Observable<any> {
    const apiUrl = environment.baseAPIURL + `DeleteCompareGroup`;
    return this.http.post(apiUrl, id);
  }

  updateCompareGroup(memberList: CompareGroupMemberListDTO): Observable<any> {
    const apiUrl = environment.baseAPIURL + `SaveCompareGroup`;
    return this.http.post(apiUrl, memberList);
  }
}
